import type { ProposalStatus } from '../lib/api';

const STYLES: Record<ProposalStatus, string> = {
  draft: 'bg-paper-3 text-ink-faint',
  published: 'bg-accent-tint text-accent-deep',
  signed: 'bg-gold-soft/40 text-[#6b4d24]',
  archived: 'bg-ink/8 text-ink-faint',
};

const LABELS: Record<ProposalStatus, string> = {
  draft: 'Draft',
  published: 'Published',
  signed: 'Signed',
  archived: 'Archived',
};

export default function StatusChip({ status }: { status: ProposalStatus }) {
  return (
    <span
      className={`status-chip mono-label inline-flex items-center rounded-full px-3 py-1 ${STYLES[status]}`}
    >
      {LABELS[status]}
    </span>
  );
}
